import React, { Component } from 'react';

import { Alert, Button, Dropdown, Image, Modal, Table, Pagination } from 'react-bootstrap';

import ChangeMapSelector from './ChangeMapSelector.js';
import RecordingInfo from './RecordingInfo.js';

import SystemUtils from '../SystemUtils';
import ModalConversion from './ModalConversion.js';

import ConfirmDeletePopup from '../Controls/ConfirmDeletePopup.js';

import './RecordingsList.css';
import '../Controls/MusterTableStyle.css';

//Filename a File-dropdown download saves as: the recording name in front of the map file's
//basename, so downloads from different recordings do not all collide on e.g.
//'global_wildcat.ply' in the user's download folder.
export const downloadFilename = (recording, mapFile) => {
    const base = mapFile.substring(mapFile.lastIndexOf('/') + 1);
    return recording + '_' + base;
};

class RecordingsList extends Component {

    confirmDeletePopup = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            startIndex: 0,
            pageSize: Math.max(1, parseInt((window.innerHeight - 150.0) / 200)), //190 is the height of each line, 150 is the height of the progress bar; clamp to >=1
            pageId: 1,
            numClouds: 0,
            filterCategoryId: -1,
            categoryTitle: 'Category',
            musterTitle: 'Muster #',
            assetTitle: 'Asset',
            files: [],
            categories: [],
            assets: [],
            statuses: [],
            showStatusPopup: false,
            statusFile: null,
            musterPoints: [],
            processes: [],
            workflows: [],
            activeFile: null,
            showConversion: false,
            conversionMsg: '',
            sortFilter: 'filename',
            sortOrder: 'ASC',
            renderAlert: false,
            alertMsg: '',
            alertSuccess: false,
            strCategoryFilter: '',
            showVideoPlayer: false,
            videoRecording: '',
            videoFile: '',
            videoList: []
        };

        //console.log("reload list");
        //console.log(this.state);
        //console.log(this.props.recordingPageId);

        this.changeMapSelectorPopup = React.createRef()
        this.recordingInfoPopup = React.createRef()
    }

    componentDidMount() {

        /*
         * startIndex: 0
pageSize: 4
sortFilter: filename
sortOrder: DESC
categoryId: 14
*/

        let pageId = localStorage.getItem('RecordingsList::pageId');
        if (pageId != null)
        {
            this.setState({ pageId: parseInt(pageId) });
        }

        let newStartIndex = localStorage.getItem('RecordingsList::startIndex');
        if (newStartIndex != null)
        {
            this.setState({ startIndex: parseInt(newStartIndex) });
        }

        let sortFilter = localStorage.getItem('RecordingsList::sortFilter');
        if (sortFilter != null)
        {
            this.setState({ sortFilter: sortFilter });
        }

        let sortOrder = localStorage.getItem('RecordingsList::sortOrder');
        if (sortOrder != null)
        {
            this.setState({ sortOrder: sortOrder });
        }

        let filterCategoryId = localStorage.getItem('RecordingsList::filterCategoryId');
        if (filterCategoryId != null)
        {
            this.setState({ filterCategoryId: parseInt(filterCategoryId) });
        }


        //console.log("did mount");
        //console.log("getItem(RecordingList::pageId)=" + pageId);
        //console.log("getItem(RecordingList::startIndex)=" + newStartIndex);
        //console.log("getItem(RecordingList::sortFilter)=" + sortFilter);
        //console.log("getItem(RecordingList::sortOrder)=" + sortOrder);
        //console.log("state.pageSize=" + this.state.pageSize);

        // Default to the state values when localStorage is empty (first load), otherwise the body
        // below would send "null" for startIndex/sortFilter/sortOrder/categoryId.
        if (newStartIndex == null) newStartIndex = this.state.startIndex;
        if (sortFilter == null) sortFilter = this.state.sortFilter;
        if (sortOrder == null) sortOrder = this.state.sortOrder;
        if (filterCategoryId == null) filterCategoryId = this.state.filterCategoryId;

        fetch('recordings_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + newStartIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + sortFilter + "&sortOrder=" + sortOrder + "&categoryId=" + filterCategoryId
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({ files: data });
        })
        .catch(console.log)



        fetch('get_category_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ categoryTitle: data[0].value });
            }
        })
        .catch(console.log)

        fetch('get_muster_point_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ musterTitle: data[0].value });
            }
        })
        .catch(console.log)

        fetch('get_asset_string', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
            if (data && data[0] && data[0].value) {
                this.setState({ assetTitle: data[0].value });
            }
        })
        .catch(console.log)

        fetch('muster_point_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0"
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ musterPoints: data });
        })
        .catch(console.log)

        fetch('category_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all categories
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ categories: data });
        })
        .catch(console.log)

        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all assets
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ assets: data });
        })
        .catch(console.log)

        fetch('status_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ statuses: data });
        })
        .catch(console.log)



        fetch('process_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all processes
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ processes: data });
        })
        .catch(console.log)



        fetch('workflow_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=-1&pageCount=0" //all processes
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ workflows: data });
        })
        .catch(console.log)



        fetch('cloud_stats', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "filterCategoryId=" + filterCategoryId //all processes
        })
        .then(res => res.json())
        .then((data) => {

            this.setState({
                numClouds: data[0].numClouds
            });
        })
        .catch(console.log)

    }

    handleDelete = filename => event => {
        event.preventDefault();
        this.confirmDeletePopup.current.request(() => this.performDelete(filename));
    }

    performDelete = (filename) => {

        fetch('cloud_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "filename=" + encodeURIComponent(filename)
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].delete)
            {
                fetch('recordings_list', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder + "&categoryId=" + this.state.filterCategoryId
                })
                .then(res => res.json())
                .then((data) => {
                    this.setState({ files: data });
                })
                .catch(console.log);
            }
        })
        .catch(console.log)
    }

    handleMapConvertEvent = (e) => {
        var objConvert = JSON.parse(e.data);

        //console.log(objConvert);

        this.setState({
            conversionMsg: objConvert.mapName + ' ' + objConvert.msg
        });

        if (2 === objConvert.conversionState)
        {
            this.eventSource.close();

            this.setState({
                showConversion: false
            });

            fetch('recordings_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder + "&categoryId=" + this.state.filterCategoryId
            })
            .then(res => res.json())
            .then((data) => {
            this.setState({ files: data });
            })
            .catch(console.log)
        }
        else if (-1 === objConvert.conversionState)
        {
            this.eventSource.close();
        }
    }

    handleConvert = file => event => {
        event.preventDefault();

        if (file.convertedMapList.length > 0)
        {
            this.props.openMap(file.filename);
        }
        else
        {
            if (1 === this.props.accessLevel)
            {
                this.setState({
                        showConversion: true,
                        conversionMsg: "Converting..."
                    });

                    //convert file
                    this.eventSource = new EventSource('map_convert?mapName=' + file.filename);
                    this.eventSource.onmessage = e => this.handleMapConvertEvent(e);
            }
        }
    }

    hideConvert = (e) => {
        this.setState({
            showConversion: false,
            conversionMsg: ""
        });
    }

    renderConvert = () => {
        return (
            <Modal
              show={this.state.showConversion}
              onHide={this.hideConvert}
              backdrop="static"
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Converting Map</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <ModalConversion conversionMsg={this.state.conversionMsg} />
            </Modal.Body>

            </Modal>
        )
    }

    showPreviewVideo = (file) => {
        if (file.previewVideo && file.previewVideo.length > 0)
        {
            let videoList = (file.videoList || '').split(', ').filter(name => name.length > 0);

            if (0 === videoList.length)
            {
                videoList = [file.previewVideo];
            }

            this.setState({
                showVideoPlayer: true,
                videoRecording: file.filename,
                videoFile: file.previewVideo,
                videoList: videoList
            });
        }
    }

    hideVideoPlayer = () => {
        this.setState({ showVideoPlayer: false, videoRecording: '', videoFile: '', videoList: [] });
    }

    handleVideoSelect = (event) => {
        this.setState({ videoFile: event.target.value });
    }

    renderVideoPlayer = () => {
        let videoUrl = 'maps/' + this.state.videoRecording + '/' + this.state.videoFile;

        return (
            <Modal
              show={this.state.showVideoPlayer}
              onHide={this.hideVideoPlayer}
              centered
              size="lg"
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Camera Preview</h1></center></Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <video key={videoUrl} src={videoUrl} controls autoPlay muted playsInline style={{ width: '100%' }} />
                <select className="videoSelect" value={this.state.videoFile} onChange={this.handleVideoSelect}>
                    {this.state.videoList.map((name) => (
                        <option key={name} value={name}>{name}</option>
                    ))}
                </select>
            </Modal.Body>

            </Modal>
        )
    }

    handleDownload = filename => event => {
        event.preventDefault();

        fetch('event_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "info=Request download " + filename
        })
        .then(res => res.json())
        .then(data =>
        {
            var element = document.createElement('a');
            element.setAttribute('href', 'maps/' + encodeURIComponent(filename));
            element.setAttribute('download', filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        })
        .catch(console.log)
    }

    handleCategoryUpdate = (eventKey, event) => {
        event.preventDefault();

        var obj = eventKey.split(",");

        fetch('cloud_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "filename=" + obj[1] + "&categoryId=" + obj[0]
        })
        .then(res => res.json())
        .then(data =>
        {


            fetch('event_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "info=Change " + obj[1] + " category to " + obj[0]
            })
            .catch(console.log)

            fetch('recordings_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder + "&categoryId=" + this.state.filterCategoryId
            })
            .then(res => res.json())
            .then((data) => {
            this.setState({ files: data });
            })
            .catch(console.log)
        })
        .catch(console.log)

    }

    handleMusterPointUpdate = (eventKey, event) => {
        event.preventDefault();

        var obj = eventKey.split(",");

        fetch('cloud_update', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "filename=" + obj[1] + "&musterPointId=" + obj[0]
        })
        .then(res => res.json())
        .then(data =>
        {


            fetch('event_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "info=Change " + obj[1] + " muster point to " + obj[0]
            })
            .catch(console.log)

            fetch('recordings_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder + "&categoryId=" + this.state.filterCategoryId
            })
            .then(res => res.json())
            .then((data) => {
            this.setState({ files: data });
            })
            .catch(console.log)
        })
        .catch(console.log)

    }


    handleProcessSelect = (eventKey, event) => {
        event.preventDefault();

        var obj = eventKey.split(",");
        //console.log(obj);
        //console.log("Add processes to the pipeline and exec pipeline");

        fetch('pipeline_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "processId=" + obj[0] + "&recording=" + obj[1]
        })
        .then(res => res.json())
        .then(data =>
        {

            var msg = data[0].Msg;
            var success = data[0].Success === 'true';
            var executor = data[0].Executor === 'true';

            if (!success) {
                this.setState({ renderAlert: true, alertMsg: msg, alertSuccess: false });
                return;
            }

            //console.log("pipeline add executor = " + executor);

            if (executor) //else executor is already running
            {
                fetch('process_executor', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: ""
                })
                .then(res => res.json())
                .then((data) => {

                    this.setState({
                        renderAlert: true,
                        alertMsg: msg,
                        alertSuccess: success
                    });

                    setTimeout(this.hideAlert, 3000)
                })
                .catch(console.log)
            }

        })
        .catch(console.log)
    }

    handleProcessAll = () => {

        fetch('process_all', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: ""
        })
        .then(res => res.json())
        .then(data =>
        {
            var msg = data[0].Msg;
            var success = data[0].Success === 'true';
            var executor = data[0].Executor === 'true';

            if (!success) {
                this.setState({ renderAlert: true, alertMsg: msg, alertSuccess: false });
                return;
            }

            this.setState({
                renderAlert: true,
                alertMsg: msg,
                alertSuccess: success
            });

            setTimeout(this.hideAlert, 3000)

            if (executor) //else executor is already running
            {
                fetch('process_executor', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: ""
                })
                .catch(console.log)
            }
        })
        .catch(console.log)
    }

    handleWorkflowSelect = (eventKey, event) => {
        event.preventDefault();

        var obj = eventKey.split(",");

        //console.log(obj);
        //console.log("Add processes to the pipeline and exec pipeline");

        fetch('pipeline_add', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "workflowId=" + obj[0] + "&recording=" + obj[1]
        })
        .then(res => res.json())
        .then(data =>
        {

            var msg = data[0].Msg;
            var success = data[0].Success === 'true';
            var executor = data[0].Executor === 'true';

            if (!success) {
                this.setState({ renderAlert: true, alertMsg: msg, alertSuccess: false });
                return;
            }

            //console.log("pipeline2 add executor = " + executor);

            if (executor) //else executor is already running
            {
                fetch('process_executor', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: ""
                })
                .then(res => res.json())
                .then((data) => {

                    this.setState({
                        renderAlert: true,
                        alertMsg: msg,
                        alertSuccess: success
                    });

                    setTimeout(this.hideAlert, 3000)
                })
                .catch(console.log)
            }

        })
        .catch(console.log)
    }

    hideAlert = () =>
    {
        this.setState({
            renderAlert: false
        });
    }

    renderAlert = () =>
    {
        if (this.state.renderAlert)
        {
            if (this.state.alertSuccess)
            {
                return (<Alert key="success" variant="success">
                            {this.state.alertMsg}
                        </Alert>);
            }
            else
            {
                return (<Alert key="danger" variant="danger">
                            {this.state.alertMsg}
                        </Alert>);
            }
        }

    }

    getButtonText = (convertedMapList) => {
        if (convertedMapList.length > 0)
        {
            return "Open";
        }
        else
        {
            if (1 === this.props.accessLevel)
            {
                return "Convert";
            }
            else
            {
                return "None";
            }
        }
        /*
        if (isConverted === "true")
            return "Open";
        else
        {
            if (isAtlas === "true")
                if (isDifferenceMap === "true")
                    return "Convert";
                else
                    return "Create Difference Map";
            else
                return "Convert";
        }
        */
    }

    getButtonDisabled = uploadState => {

        if (4 === parseInt(uploadState))
        {
            return false;
        }
        else
        {
            return true;
        }
    }

    handleDownloadMap = (eventKey, event) => {
        event.preventDefault();

        //var obj = eventKey.split(",");

        //console.log("handleDownloadMap");
        //console.log(obj);
    }

    renderHeaderCategoryFilter = () => {

        let localCategories = this.state.categories;

        //console.log("localCategories");
        //console.log(localCategories);

        if (1 === this.props.accessLevel)
        {
            if (localCategories.length > 0)
            {
                let firstItem = localCategories[0];

                //console.log("first item");
                //console.log(firstItem);
                //console.log(firstItem.title);

                if (firstItem.title !== "No Category")
                {
                    let noCat = { categoryId: '-1', title: 'No Category', colour: '000000' };
                    localCategories.unshift(noCat);
                }
            }
        }

        return this.state.categories.map((category) => (
            <Dropdown.Item as="button" eventKey={[category.categoryId]} onSelect={this.reloadPageWithCategoryFilter}  style={{ backgroundColor: "#FFFFFF" }}>{category.title}</Dropdown.Item>
        ))
    }

    getAssetId = (assetName) => {
        for (let i = 0; i < this.state.assets.length; i++) {
            if (this.state.assets[i].asset === assetName) {
                return this.state.assets[i].assetId;
            }
        }
        return null;
    }

    renderCategoryData = file => {
        //only offer the categories linked to this recording's asset (categories.assetId);
        //a recording with no asset yet can still pick from every category
        const assetId = this.getAssetId(file.asset);
        let categories = this.state.categories;
        if (null !== assetId) {
            categories = categories.filter((category) => String(category.assetId) === String(assetId));
        }
        return categories.map((category) => (
            <Dropdown.Item as="button" eventKey={[category.categoryId, file.filename]} onSelect={this.handleCategoryUpdate}>{category.title}</Dropdown.Item>
        ))
    }

    getAssetColour = (assetName) => {
        if (!assetName) {
            return "6c757d";
        }
        for (let i = 0; i < this.state.assets.length; i++) {
            if (this.state.assets[i].asset === assetName) {
                return this.state.assets[i].colour;
            }
        }
        return "6c757d";
    }

    getMusterPointColour = (musterName) => {
        if (!musterName) {
            return "6c757d";
        }
        for (let i = 0; i < this.state.musterPoints.length; i++) {
            if (this.state.musterPoints[i].title === musterName) {
                return this.state.musterPoints[i].colour;
            }
        }
        return "6c757d";
    }

    renderAssetData = filename => {
        return this.state.assets.map((asset) => (
            <Dropdown.Item as="button" eventKey={[asset.asset, filename]} onSelect={this.handleSetAsset(asset.assetId, asset.asset, filename)}>{asset.asset}</Dropdown.Item>
        ))
    }

    getCategoryId = (categoryTitle) => {
        for (let i = 0; i < this.state.categories.length; i++) {
            if (this.state.categories[i].title === categoryTitle) {
                return this.state.categories[i].categoryId;
            }
        }
        return null;
    }

    renderMusterPointData = file => {
        //only offer the muster points linked to this recording's category
        //(muster_points.categoryId); a recording with no category yet can pick from all of them
        const categoryId = this.getCategoryId(file.category);
        let musterPoints = this.state.musterPoints;
        if (null !== categoryId) {
            musterPoints = musterPoints.filter((mp) => String(mp.categoryId) === String(categoryId));
        }
        return musterPoints.map((mp) => (
            <Dropdown.Item as="button" eventKey={[mp.musterPointId, mp.title, file.filename]} onSelect={this.handleSetMusterPoint(mp.musterPointId, mp.title, file.filename)}>{mp.title}</Dropdown.Item>
        ))
    }

    handleSetAsset = (assetId, assetName, filename) => () => {

        fetch('set_recording_asset', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "recording=" + filename + "&assetId=" + assetId + "&asset=" + assetName
        })
        .then(res => res.json())
        .then(data =>
        {
            this.reloadPage();
        })
        .catch(console.log)
    }

    handleSetMusterPoint = (musterPointId, musterName, filename) => () => {

        fetch('set_recording_muster_point', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "recording=" + filename + "&musterPointId=" + musterPointId + "&muster=" + musterName
        })
        .then(res => res.json())
        .then(data =>
        {
            this.reloadPage();
        })
        .catch(console.log)
    }

    renderProcessData = filename => {
        return this.state.processes.map((proc) => (
            <Dropdown.Item as="button" eventKey={[proc.ProcessId, filename]} onSelect={this.handleProcessSelect}>{proc.Name}</Dropdown.Item>
        ))
    }

    renderWorkflowData = filename => {
        return this.state.workflows.map((workflow) => (
            <Dropdown.Item as="button" eventKey={[workflow.WorkflowId, filename]} onSelect={this.handleWorkflowSelect}>{workflow.Name}</Dropdown.Item>
        ))
    }


    renderDownloadData = file => {
        //console.log("renderdownloaddata");
        //console.log(file);
        if (file.downloadMapList.length > 0)
        {
            const arrFiles = file.downloadMapList.split(", ");
            if (arrFiles.length > 0)
            {
                let htmlItems = [];
                for (var i = 0; i < arrFiles.length; i++)
                {
                    //console.log(arrFiles[i]);
                    htmlItems.push(<Dropdown.Item className="downloadLink" href={"maps/" +  file.filename + "/" + arrFiles[i]} download={downloadFilename(file.filename, arrFiles[i])}>Download {arrFiles[i]} File</Dropdown.Item>);
                }
                return (
                    <Dropdown.Menu className="downloadDropdown">
                    {htmlItems}
                    </Dropdown.Menu>
                )
            }
            else
            {
                //console.log('nothing to download, array zero');
                return (
                    <Dropdown.Menu className="downloadDropdown">
                    </Dropdown.Menu>
                )
            }
        }
        else //nothing to download
        {
            //console.log('nothing to download');
            return (
                <Dropdown.Menu className="downloadDropdown">
                </Dropdown.Menu>
            )
        }
    }

    showRecordingInfo = (filename, comment) => {;
        this.recordingInfoPopup.current.show(filename, comment);
    }

    renderStatus = (file) => {
        let statusId = parseInt(file.statusId);

        if (isNaN(statusId) || statusId < 0 || statusId > 5)
            statusId = 0;

        return (
            <span className={"statusCircle statusCircle-" + statusId} onClick={() => this.openStatusPopup(file)} style={{ cursor: 'pointer' }}>
                <span className="statusTooltip">{file.status}</span>
            </span>
        )
    }

    openStatusPopup = (file) => {
        this.setState({ showStatusPopup: true, statusFile: file });
    }

    closeStatusPopup = () => {
        this.setState({ showStatusPopup: false });
    }

    getStatusName = (statusId) => {
        for (let i = 0; i < this.state.statuses.length; i++) {
            if (String(this.state.statuses[i].id) === String(statusId)) {
                return this.state.statuses[i].status;
            }
        }
        return '';
    }

    handleStatusSelected = (e) => {
        const statusId = e.target.value;
        const file = this.state.statusFile;

        fetch('set_recording_status', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "recording=" + file.filename + "&statusId=" + statusId
        })
        .then(res => res.json())
        .then(data => {
            if (data && data[0] && data[0].success === 'true') {
                file.statusId = statusId;
                file.status = this.getStatusName(statusId);
            }
            this.setState({ showStatusPopup: false });
        })
        .catch(() => {
            this.setState({ showStatusPopup: false });
        })
    }

    //no backdrop="static" here on purpose: clicking off the popup must close it
    renderStatusModal = () => {
        const file = this.state.statusFile;

        return (
            <Modal
              show={this.state.showStatusPopup}
              onHide={this.closeStatusPopup}
              centered
            >
            <Modal.Header closeButton>
                <Modal.Title><center><h1 class="pageTitle">Update Status</h1></center></Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <select value={file ? file.statusId : '0'} onChange={this.handleStatusSelected} style={{ width: '100%', fontSize: '1.5rem', padding: '0.5rem' }}>
                    { this.state.statuses.map((status) => (
                        <option value={status.id}>{status.status}</option>
                    )) }
                </select>
            </Modal.Body>
            </Modal>
        )
    }

    //Size and Upload Date pop up the uploader's username, same pattern as the status circle
    renderUsernameTooltip = (file) => {
        if (file.username && file.username.length > 0)
            return <span className="usernameTooltip">{file.username}</span>;

        return null;
    }

    renderSizeCell = (file) => {
        return (
            <span className="usernameHover">
                {SystemUtils.GetSizeString(file.size)}
                {this.renderUsernameTooltip(file)}
            </span>
        )
    }

    renderUploadDateCell = (file) => {
        return (
            <span className="usernameHover">
                {file.uploadDate}
                {this.renderUsernameTooltip(file)}
            </span>
        )
    }

    renderListData = () => {
        if (1 === this.props.accessLevel)
        {
            return this.state.files.map((file) => (
                <tbody>
                    <tr>
                        <td className="cloudList">{this.renderStatus(file)}</td>
                        <td>
                            { this.renderPreview(file) }
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="filename" style={{ backgroundColor: "#" + file.colour }}>
                                {file.filename}
                            </Dropdown.Toggle>

                            { this.renderDownloadData(file) }
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            {this.renderSizeCell(file)}
                        </td>
                        <td className="cloudList">
                            {this.renderUploadDateCell(file)}
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="asset" style={{ backgroundColor: "#" + (this.getAssetColour(file.asset)) }}>
                                {file.asset || 'None'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {this.renderAssetData(file.filename)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="category" style={{ backgroundColor: "#" + file.categoryColour }}>
                                {file.category}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {this.renderCategoryData(file)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="musterPoint" style={{ backgroundColor: "#" + (this.getMusterPointColour(file.muster)) }}>
                                {file.muster || 'None'}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {this.renderMusterPointData(file)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <Button size="lg" onClick={() => this.showRecordingInfo(file.filename, file.comment)}>{file.comment}</Button>
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="process">
                                Add workflow to queue
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {this.renderWorkflowData(file.filename)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <form name="frmConvert" onSubmit={this.handleConvert(file)}>
                            <Button variant="danger" size="lg" type="submit" disabled={this.getButtonDisabled(file.uploadState)}>{this.getButtonText(file.convertedMapList)}</Button><input type="hidden" name="filename" value={file.filename} /></form>
                        </td>
                        <td className="cloudList">
                            <form name="frmDelete" onSubmit={this.handleDelete(file.filename)}>
                            <Button variant="danger" size="lg" type="submit">Delete</Button><input type="hidden" name="filename" value={file.filename} /></form>
                        </td>
                    </tr>
                </tbody>
            ))
        }
        else
        {
            return this.state.files.map((file) => (
                <tbody>
                    <tr>
                        <td className="cloudList">{this.renderStatus(file)}</td>
                        <td>
                            { this.renderPreview(file) }
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="filename" style={{ backgroundColor: "#" + file.colour }}>
                                {file.filename}
                            </Dropdown.Toggle>

                            { this.renderDownloadData(file) }
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            {this.renderSizeCell(file)}
                        </td>
                        <td className="cloudList">
                            {this.renderUploadDateCell(file)}
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="asset" style={{ backgroundColor: "#" + (this.getAssetColour(file.asset)) }}>
                                {file.asset || 'None'}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {this.renderAssetData(file.filename)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="category" style={{ backgroundColor: "#" + file.categoryColour }}>
                                {file.category}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {this.renderCategoryData(file)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <Dropdown>
                            <Dropdown.Toggle size="lg" variant="success" id="musterPoint" style={{ backgroundColor: "#" + (this.getMusterPointColour(file.muster)) }}>
                                {file.muster || 'None'}
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                {this.renderMusterPointData(file)}
                            </Dropdown.Menu>
                            </Dropdown>
                        </td>
                        <td className="cloudList">
                            <Button size="lg" onClick={() => this.showRecordingInfo(file.filename, file.comment)}>{file.comment}</Button>
                        </td>
                        <td className="cloudList">
                            <form name="frmConvert" onSubmit={this.handleConvert(file)}>
                            <Button variant="danger" size="lg" type="submit" disabled={this.getButtonDisabled(file.uploadState)}>{this.getButtonText(file.convertedMapList)}</Button><input type="hidden" name="filename" value={file.filename} /></form>
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            ))
        }
    }



    renderPagination = () => {
        let numPages = Math.ceil((this.state.numClouds) / this.state.pageSize);
        let items = [];
        let active = this.state.pageId;

        //console.log("renderPagination");
        //console.log("this.numClouds=" + this.numClouds);
        //console.log("this.state.pageSize=" + this.state.pageSize);
        //console.log("numPages=" + numPages);
        //console.log("active=" + active);


        var iStart = active - 5;
        var iFinish = active + 5;

        //console.log("iActiveBefore=" + active);
        //console.log("iStartBefore=" + iStart);
        //console.log("iFinishBefore=" + iFinish);

        if (iStart < 1)
            iStart = 1;

        if (iFinish > numPages)
            iFinish = numPages;

        //console.log("active=" + active);
        //console.log("numPages=" + numPages);
        //console.log("iStart=" + iStart);
        //console.log("iFinish=" + iFinish);

        //for (let number = 1; number <=numPages; number++)
        for (let number = iStart; number <=iFinish; number++)
        {
            items.push(
                <Pagination.Item className="pageClouds" key={number} active={number === active}>
                {number}
                </Pagination.Item>,
            );
        }

        return (
            <Pagination onClick={this.loadPage}>{items}</Pagination>
        )
    }

    createChangeMap = () => {
        fetch('create_changemap', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize
        })
        .then(res => res.json())
        .then((data) => {
        this.setState({ files: data });
        })
        .catch(console.log)
    }

    reloadPageWithCategoryFilter = (eventKey, event) => {

        var obj = eventKey.split(",");

        this.setState({
            filterCategoryId: obj[0],
            pageId: 1, //set the pageId back to 1 when you change category otherwise you could be on page 40 of the unfiltered tab and when filtering for category there is nothing.
            startIndex: 0
        });

        localStorage.setItem('RecordingsList::filterCategoryId', obj[0]);
        localStorage.setItem('RecordingsList::pageId', 1);
        localStorage.setItem('RecordingsList::startIndex', 0);

        if (-1 === obj[0]) //this is no category selected
        {
            fetch('recordings_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=0&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder
            })
            .then(res => res.json())
            .then((data) => {

                this.setState({ files: data });

                //console.log("reloading stats2");

                fetch('cloud_stats', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: ""
                })
                .then(res => res.json())
                .then((data) => {

                    //console.log("numclouds " + data[0].numClouds);

                    this.setState({
                        numClouds: data[0].numClouds
                    });

                })
                .catch(console.log)

            })
            .catch(console.log)
        }
        else
        {
            fetch('recordings_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=0&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder + "&categoryId=" + obj[0]
            })
            .then(res => res.json())
            .then((data) => {

                this.setState({ files: data });

                //console.log("reloading stats2");

                fetch('cloud_stats', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                    },
                    body: "filterCategoryId=" + this.state.filterCategoryId //all processes
                })
                .then(res => res.json())
                .then((data) => {

                    //console.log("numclouds " + data[0].numClouds);

                    this.setState({
                        numClouds: data[0].numClouds
                    });

                })
                .catch(console.log)

            })
            .catch(console.log)
        }

        //console.log("reloadPage2 .filter=" + this.state.sortFilter  + " .order=" + this.state.sortOrder);
    }

    reloadPage = (filter, order) => {
        // Default to the current sort when called with no args (e.g. after upload / closing a popup).
        if (filter === undefined) filter = this.state.sortFilter;
        if (order === undefined) order = this.state.sortOrder;
        fetch('recordings_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + this.state.startIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + filter + "&sortOrder=" + order + "&categoryId=" + this.state.filterCategoryId
        })
        .then(res => res.json())
        .then((data) => {
            this.setState({ files: data });
        })
        .catch(console.log)
    }

    loadPage = e => {
        if (typeof e.target.text !== "undefined")
        {
            let newPageId = parseInt(e.target.text);
            let newStartIndex = (newPageId-1) * this.state.pageSize;

            this.setState({
                pageId: newPageId,
                startIndex: newStartIndex
            });

            //console.log("reload list2");
            //console.log(this.state);


            //console.log("setItem(RecordingList::pageId)=" + newPageId)
            //console.log("setItem(RecordingList::startIndex)=" + newStartIndex)

            localStorage.setItem('RecordingsList::pageId', newPageId);
            localStorage.setItem('RecordingsList::startIndex', newStartIndex);


            fetch('recordings_list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: "startIndex=" + newStartIndex + "&pageSize=" + this.state.pageSize + "&sortFilter=" + this.state.sortFilter + "&sortOrder=" + this.state.sortOrder + "&categoryId=" + this.state.filterCategoryId
            })
            .then(res => res.json())
            .then((data) => {
            this.setState({ files: data });
            })
            .catch(console.log)

            //console.log("reloadPage3 .filter=" + this.state.sortFilter  + " .order=" + this.state.sortOrder);
        }
    }

    sortByFilename = () => {

        var sortOrder = "ASC";

        if (this.state.sortOrder === "ASC")
            sortOrder = "DESC";

        this.setState({
            sortFilter: "filename",
            sortOrder: sortOrder
        });

        localStorage.setItem('RecordingsList::sortFilter', "filename");
        localStorage.setItem('RecordingsList::sortOrder', sortOrder);



        //console.log("reloadPage4 .filter=" + this.state.sortFilter  + " .order=" + this.state.sortOrder);

        this.reloadPage("filename", sortOrder);
    }

    renderFilenameSortButton()
    {
        if (this.state.sortFilter === "filename")
        {
            if (this.state.sortOrder === "ASC")
            {
                return (
                    <Image src="sortDown.png" width="24" />
                )
            }
            else
            {
                return (
                    <Image src="sortUp.png" width="24" />
                )
            }
        }
        else
            return (
                <Image src="sortNone.png" width="24" />
            )
    }

    sortBySize = () => {

        var sortOrder = "ASC";

        if (this.state.sortOrder === "ASC")
            sortOrder = "DESC";

        this.setState({
            sortFilter: "size",
            sortOrder: sortOrder
        });

        localStorage.setItem('RecordingsList::sortFilter', "size");
        localStorage.setItem('RecordingsList::sortOrder', sortOrder);

        this.reloadPage("size", sortOrder);
    }

    renderSizeSortButton()
    {
        if (this.state.sortFilter === "size")
        {
            if (this.state.sortOrder === "ASC")
            {
                return (
                    <Image src="sortDown.png" width="24" />
                )
            }
            else
            {
                return (
                    <Image src="sortUp.png" width="24" />
                )
            }
        }
        else
            return (
                <Image src="sortNone.png" width="24" />
            )
    }

    sortByUploadDate = () => {

        var sortOrder = "ASC";

        if (this.state.sortOrder === "ASC")
            sortOrder = "DESC";

        this.setState({
            sortFilter: "uploadDate",
            sortOrder: sortOrder
        });

        localStorage.setItem('RecordingsList::sortFilter', "uploadDate");
        localStorage.setItem('RecordingsList::sortOrder', sortOrder);

        this.reloadPage("uploadDate", sortOrder);
    }

    renderUploadDateSortButton()
    {
        if (this.state.sortFilter === "uploadDate")
        {
            if (this.state.sortOrder === "ASC")
            {
                return (
                    <Image src="sortDown.png" width="24" />
                )
            }
            else
            {
                return (
                    <Image src="sortUp.png" width="24" />
                )
            }
        }
        else
            return (
                <Image src="sortNone.png" width="24" />
            )
    }

    sortByCategory = () => {

        var sortOrder = "ASC";

        if (this.state.sortOrder === "ASC")
            sortOrder = "DESC";

        this.setState({
            sortFilter: "category",
            sortOrder: sortOrder
        });

        localStorage.setItem('RecordingsList::sortFilter', "category");
        localStorage.setItem('RecordingsList::sortOrder', sortOrder);

        this.reloadPage("category", sortOrder);
    }

    renderCategorySortButton()
    {
        if (this.state.sortFilter === "category")
        {
            if (this.state.sortOrder === "ASC")
            {
                return (
                    <Image src="sortDown.png" width="24" />
                )
            }
            else
            {
                return (
                    <Image src="sortUp.png" width="24" />
                )
            }
        }
        else
            return (
                <Image src="sortNone.png" width="24" />
            )
    }

    renderHeader = () => {
        if (1 === this.props.accessLevel)
        {
            return (
                <thead>
                    <tr>
                        <th><h3>Status</h3></th>
                        <th><h3>Preview</h3></th>
                        <th onClick={this.sortByFilename}><h3>File { this.renderFilenameSortButton() }</h3></th>
                        <th onClick={this.sortBySize}><h3>Size</h3></th>
                        <th onClick={this.sortByUploadDate}><h3>Upload Date { this.renderUploadDateSortButton() }</h3></th>
                        <th><h3>{this.state.assetTitle}</h3></th>
                        <th onClick={this.sortByCategory}><h3>{this.state.categoryTitle} { this.renderCategorySortButton() }</h3></th>
                        <th><h3>{this.state.musterTitle}</h3></th>
                        <th><h3>Comment</h3></th>
                        <th><h3>Process</h3></th>
                        <th><h3>View Maps</h3></th>
                        <th><h3>Delete</h3></th>
                    </tr>
                </thead>
            )
        }
        else
        {
            return (
                <thead>
                    <tr>
                        <th><h3>Status</h3></th>
                        <th><h3>Preview</h3></th>
                        <th onClick={this.sortByFilename}><h3>File { this.renderFilenameSortButton() }</h3></th>
                        <th onClick={this.sortBySize}><h3>Size</h3></th>
                        <th onClick={this.sortByUploadDate}><h3>Upload Date { this.renderUploadDateSortButton() }</h3></th>
                        <th><h3>{this.state.assetTitle}</h3></th>
                        <th onClick={this.sortByCategory}><h3>{this.state.categoryTitle} { this.renderCategorySortButton() }</h3></th>
                        <th><h3>{this.state.musterTitle}</h3></th>
                        <th><h3>Comment</h3></th>
                        <th><h3>View Maps</h3></th>
                        <th></th>
                    </tr>
                </thead>
            )
        }
    }

    renderPreview = (file) => {
        let videoStyle = { cursor: (file.previewVideo && file.previewVideo.length > 0) ? 'pointer' : 'default' };

        if ('true' === file.preview)
            return <img src={'maps/' + file.filename + '/preview.png'} width="128" alt={'maps/' + file.filename + '/preview.png does not exist'} style={videoStyle} onClick={() => this.showPreviewVideo(file)}/>;
        else
            return <img src={'noPreview.png'} width="128" alt={'maps/' + file.filename + '/preview.png does not exist'} style={videoStyle} onClick={() => this.showPreviewVideo(file)}/>;
    }

    renderCategoryText = () => {

        let filterCategoryId = localStorage.getItem('RecordingsList::filterCategoryId');

        if (filterCategoryId != null)
        {
            let localCategories = this.state.categories;

            for (let i = 0; i < localCategories.length; i++)
            {
                let categoryId = localCategories[i].categoryId;
                //console.log("The number is " + i + " catId = " + categoryId + " filterCategoryId = " + filterCategoryId + "<br>");
                if (categoryId == filterCategoryId)
                {
                    //console.log("Category Text = " + localCategories[i].title);
                    return 'Category Filter - ' + localCategories[i].title;
                }

            }
            return 'Category Filter';
        }
        else
        {
            return 'Category Filter';
        }

    }

    render() {
        return (
            <div>

            {this.renderConvert()}
            {this.renderVideoPlayer()}
            {this.renderStatusModal()}

            <div class="paginationClouds">
            <Button className="processAllClouds" size="lg" onClick={this.handleProcessAll}>Process All</Button>
            {this.renderPagination()}
            <Dropdown className="dropCategory">
            <Dropdown.Toggle size="lg" variant="success" id="category" style={{ backgroundColor: "#d90023"}}>
                {this.renderCategoryText()}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {this.renderHeaderCategoryFilter()}
            </Dropdown.Menu>
            </Dropdown>
            </div>

            <Table className="cloudListTable musterStyleTable">
            {this.renderHeader()}
            {this.renderListData()}
            <ChangeMapSelector ref={this.changeMapSelectorPopup} reloadRecordingsList={this.reloadPage} />
            <RecordingInfo ref={this.recordingInfoPopup} reloadRecordingsList={this.reloadPage} accessLevel={this.props.accessLevel} />
            </Table>
            {this.renderAlert()}
            <ConfirmDeletePopup ref={this.confirmDeletePopup} />
            </div>
        )
    }
}

export default RecordingsList;
